import { render } from "./ManageIntegrationGroups.vue?vue&type=template&id=8be5bc7e"
import script from "./ManageIntegrationGroups.vue?vue&type=script&lang=js"
export * from "./ManageIntegrationGroups.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__